import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from '@radix-ui/react-icons';
import clsx from 'clsx';
import { ReactNode } from 'react';

type Props = {
  id: string;
  label: string | ReactNode;
  value?: string;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  smallLabel?: boolean;
  checked?: boolean;
  defaultChecked?: boolean;
  variant?: 'default' | 'baseline' | 'search';
} & Pick<CheckboxPrimitive.CheckboxProps, 'onCheckedChange'>;

function Checkbox(props: Props) {
  const {
    id,
    label,
    name,
    value = 'checked',
    disabled,
    required,
    variant = 'default',
    smallLabel,
    defaultChecked,
    checked,
    onCheckedChange,
  } = props;

  return (
    <div
      className={clsx('checkbox', {
        'checkbox--baseline': variant === 'baseline',
        'checkbox--search': variant === 'search',
      })}
    >
      <CheckboxPrimitive.Root
        className='checkbox__root'
        id={id}
        name={name ?? id}
        disabled={disabled}
        value={value}
        required={required}
        defaultChecked={defaultChecked}
        checked={checked}
        onCheckedChange={onCheckedChange}
      >
        <CheckboxPrimitive.Indicator className='checkbox__indicator'>
          <CheckIcon width={22} height={22} />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <label
        className={clsx('checkbox__label', {
          'checkobx__label--small': smallLabel,
        })}
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
}

export default Checkbox;
